import type { FieldValues, UseFormHandleSubmit, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { Alert, Button } from 'components/common';
import { Text } from 'components/forms';
import type { FormError } from 'components/forms/types';
import { format } from 'libs';

interface ProfileFormProps {
  errors: Record<string, FormError>;
  handleSubmit: UseFormHandleSubmit<FieldValues>;
  isCancellingPendingEmail?: boolean;
  isSubmitting?: boolean;
  onCancelPendingEmail: () => void;
  onSubmit: (formValues: FieldValues) => void;
  pendingEmail?: string;
  register: UseFormRegister<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
}

const ProfileForm = ({
  errors,
  handleSubmit,
  isCancellingPendingEmail,
  isSubmitting,
  onCancelPendingEmail,
  onSubmit,
  pendingEmail,
  register,
  setValue,
}: ProfileFormProps) => (
  <form onSubmit={handleSubmit(onSubmit)}>
    {pendingEmail && (
      <Alert testId="profile-pending-email-alert" variant="primary-light">
        <div className="align-items-center d-flex justify-content-between gap-3">
          <span>
            A verification email was sent to <strong>{pendingEmail}</strong>. Please check your inbox.
          </span>
          <Button
            disabled={isCancellingPendingEmail}
            onClick={onCancelPendingEmail}
            testId="profile-pending-email-cancel-button"
            text="bold"
            variant="border"
          >
            Cancel
          </Button>
        </div>
      </Alert>
    )}
    <Text
      testId="profile-name-update-field"
      error={errors.name}
      label="Name *"
      name="name"
      register={register('name')}
      type="text"
    />
    <Text
      testId="profile-email-update-field"
      error={errors.email}
      label="Email *"
      name="email"
      register={register('email')}
      type="email"
    />
    <Text
      testId="profile-phone-update-field"
      error={errors.phone_number}
      label="Phone"
      name="phone_number"
      register={register('phone_number', {
        onChange: (event) => {
          setValue('phone_number', format.phoneNormalize(event.target.value));
        },
      })}
      type="text"
    />
    <div className="mt-3">
      <Button disabled={isSubmitting} submit testId="profile-update-button" text="bold" variant="primary-dark">
        Update
      </Button>
    </div>
  </form>
);

export default ProfileForm;
